export default __webpack_public_path__ + "static/media/no-it-provider-hero.6a03d872.png";